/* Rquiere de mixin.js */

var shippingRequest = {
	data() {
		return {
			fromDateShippingsRequest: '2020-07-15',
			listShippingsRequest: [],
			methods: {
				shippingRequestCreate: 'shippingRequest/register',
				shippingRequestUpdate: 'shippingRequest/update',
				shippingRequestDelete: '/delete',
				shippingRequestGet: 'shippingsRequest',
				shippingRequestShow: 'shippingRequest/',
				shippingRequestShowByBarcode: 'shippingRequest/barcode/',
				shippingRequestTrackingsShippingCreate: '/trackingsShippingRequest/register',
			},
			objectShippingRequest: {
				id: null,
				user_id: null,
				user: {},
				commentary: '',
				total_price: 0,
				barcode: '',
				status_id: null,
				status: {},
				shipping: [],
				orders: [],
				created_at: null,
				updated_at: null,
				shipping_request_genesys_cabmov: [],
				shipping_request_recipient_data: null,
				legal_documents: [],
				shipping_request_trackings_shipping_request: [],
				notConsider: false,
				recipientData: {
					exists: 0,
					id: 0,
					shipping_request_id: 0,
					sendto: '',
					address: '',
					comuna: '',
					phone: '',
					number_document: '',
					email: '',
					paid_shipping: '',
					transport_id: 0,
					transport: ''
				},
			},
			objectShippingRequestRecipientData: {
				id: 0,
				shipping_request_id: 0,
				sendto: '',
				address: '',
				comuna: '',
				phone: '',
				number_document: '',
				email: '',
				paid_shipping: '',
				transport_id: 0,
				transport: null
			},
			onlyMineShippingsRequest: false,
			paginationListShippingsRequest: [],
			qrowsShippingRequest: 25,
			searchShippingsRequest: '',
			searchingShippingsRequest: false,
			savingShippingsRequest: false,
			toDateShippingsRequest: '2020-07-18',
			trackingsShippingRequestOrder: [
				{ trackings_shipping_request_id: '10', trackings_shipping_status_name: 'Atendido', trackings_order_id: '4' },
				{ trackings_shipping_request_id: '11', trackings_shipping_status_name: 'Empacado', trackings_order_id: '5' },
				{ trackings_shipping_request_id: '13', trackings_shipping_status_name: 'Despachado', trackings_order_id: '6' },
				{ trackings_shipping_request_id: '14', trackings_shipping_status_name: 'Entregado', trackings_order_id: '7' },
			]
		}
	},
	computed: {
	},
	filters: {
	},
	methods: {
		addListShippingsRequest(newShippingRequest) {
			this.listShippingsRequest.unshift(newShippingRequest)
		},
		addShippingRequestTrackingsShippingRequest(id, trackingsShippingRequestId, observation) {
			console.log('Agregando seguimiento...')
			let param = {
				'trackingsShippingRequestId': trackingsShippingRequestId,
				'observation': observation
			}
			this.$emit('showLockScreen', 'Guardando comentario . . .')
			let url = this.getApiBackend + this.methods.shippingRequestShow + id + this.methods.shippingRequestTrackingsShippingCreate
			this.axiosActionIS(url, 'POST', 'resultAddShippingRequestTrackingsShippingRequestPOST', param)
		},
		clearObjectShippingRequest() {
			this.clearObjectShippingRequestRecipientData()
			this.objectShippingRequest.shipping_request_recipient_data = [this.objectShippingRequestRecipientData]
			this.objectShippingRequest.id = 0
			this.objectShippingRequest.user_id = null
			this.objectShippingRequest.user = {}
			this.objectShippingRequest.commentary = ''
			this.objectShippingRequest.total_price = 0
			this.objectShippingRequest.barcode = ''
			this.objectShippingRequest.status_id = null
			this.objectShippingRequest.status = {}
			this.objectShippingRequest.shipping = []
			this.objectShippingRequest.orders = []
			this.objectShippingRequest.created_at = null
			this.objectShippingRequest.updated_at = null
			this.objectShippingRequest.shipping_request_genesys_cabmov = []
			this.objectShippingRequest.legal_documents = []
			this.objectShippingRequest.shipping_request_trackings_shipping_request = []
			this.objectShippingRequest.notConsider = false
			this.objectShippingRequest.recipientData.exists = 0
			this.objectShippingRequest.recipientData.id = 0
			this.objectShippingRequest.recipientData.shipping_request_id = 0
			this.objectShippingRequest.recipientData.sendto = ''
			this.objectShippingRequest.recipientData.address = ''
			this.objectShippingRequest.recipientData.comuna = ''
			this.objectShippingRequest.recipientData.phone = ''
			this.objectShippingRequest.recipientData.number_document = ''
			this.objectShippingRequest.recipientData.email = ''
			this.objectShippingRequest.recipientData.paid_shipping = ''
			this.objectShippingRequest.recipientData.transport_id = 0
			this.objectShippingRequest.recipientData.transport = ''
		},
		clearObjectShippingRequestRecipientData() {
			this.objectShippingRequestRecipientData.id = 0
			this.objectShippingRequestRecipientData.shipping_request_id = 0
			this.objectShippingRequestRecipientData.sendto = ''
			this.objectShippingRequestRecipientData.address = ''
			this.objectShippingRequestRecipientData.comuna = ''
			this.objectShippingRequestRecipientData.phone = ''
			this.objectShippingRequestRecipientData.number_document = ''
			this.objectShippingRequestRecipientData.email = ''
			this.objectShippingRequestRecipientData.paid_shipping = 0
			this.objectShippingRequestRecipientData.transport_id = 0
			this.objectShippingRequestRecipientData.transport = null
		},
		deleteShippingRequest(id) {
			this.$emit('showLockScreen', 'Borrando solicitud de envío . . .')
			this.axiosActionIS(this.getApiBackend + this.methods.shippingRequestShow + id + this.methods.shippingRequestDelete, 'DELETE', 'resultDeleteShippingRequest')
		},
		deleteItemListShippingsRequest(id) {
			let index = this.listShippingsRequest.map((el) => parseInt(el.id)).indexOf(parseInt(id))
			let shippingsRequestDeleted = this.listShippingsRequest.splice(index, 1)
		},
		getAllShippingsRequest(page = 1, statusIds = []) {
			this.listShippingsRequest = []
			this.paginationListShippingsRequest = []
			this.searchingShippingsRequest = true
			let userId = (this.onlyMineShippingsRequest) ? this.auth.id : -1
			let parameters = '?search=' + this.searchShippingsRequest + '&page=' + page + '&fromDate=' + this.fromDateShippingsRequest + '&toDate=' + this.toDateShippingsRequest + '&userId=' + userId + '&qRow=' + this.qrowsShippingRequest + '&statusId=' + statusIds
			let url = this.getApiBackend + this.methods.shippingRequestGet + parameters
			this.axiosActionIS(url, 'GET', 'resultGetAllShippingsRequest')
		},
		getShippingRequest(id) {
			this.clearObjectShippingRequest()
			this.searchingShippingsRequest = true
			let url = this.getApiBackend + this.methods.shippingRequestShow + id
			this.axiosActionIS(url, 'GET', 'getShippingRequestResult')
		},
		getShippingRequestResult(response) {
			this.searchingShippingsRequest = false
			if (response.data.success == true) {
				if (response.data.data.shipping_request_recipient_data.length == 0) {
					response.data.data.shipping_request_recipient_data = [this.objectShippingRequestRecipientData]
				}
				this.setObjectShippingRequest(response.data.data)
			}
			this.getShippingRequestResultLocal(response)
		},
		getShippingRequestResultLocal(response) {
			console.log("getShippingRequestResultLocal no desarrollado", response)
		},
		getShippingsRequestByBarcode(barcode) {
			this.axiosActionIS(this.getApiBackend + this.methods.shippingRequestShowByBarcode + barcode, 'GET', 'getShippingsRequestByBarcodeResult')
		},
		getShippingsRequestByBarcodeResult(response) {
			this.getShippingsRequestByBarcodeResultLocal(response)
		},
		getShippingsRequestByBarcodeResultLocal(response) {
			console.log('getShippingsRequestByBarcodeResultLocal no desarrollada', response)
		},
		getLegalDocumentNumberRel(item, show = 'ALL', typeLegalDocumentIdMain = 52) {
			console.log()
			let legalDocuments = []
			item.legal_documents.forEach(e => {
				legalDocuments.push({ type_legal_document_id: e.type_legal_document_id, legal_document_number: e.legal_document_number })
			})
			item.shipping_request_genesys_cabmov.forEach(e => {
				if (parseInt(e.tipocompcod) == 1 || parseInt(e.tipocompcod) == 2 || parseInt(e.tipocompcod) == 33 || parseInt(e.tipocompcod) == 39 || parseInt(e.tipocompcod) == 52) {
					legalDocuments.push({ type_legal_document_id: e.tipocompcod, legal_document_number: e.nrocomp })
				}
			})
			let result = false
			if (legalDocuments.length > 0) {
				if (show == 'ALL') {
					result = ''
					legalDocuments.forEach(e => {
						result += e.legal_document_number + ' (' + e.type_legal_document_id + ')\n'
					})
				} else if (show == 'MAIN') {
					if (legalDocuments.length == 1) {
						result = legalDocuments[0].legal_document_number
					} else {
						let index = legalDocuments.map(e => parseInt(e.type_legal_document_id)).indexOf(typeLegalDocumentIdMain)
						result = (index > -1) ? legalDocuments[index].legal_document_number : legalDocuments[0].legal_document_number
					}
				}
			}
			return result;
		},
		getNrocompGenesys(shippingRequestGenesysCabmov, type) {
			let nrocomp = 'S/N'
			let con = 0
			Object.values(shippingRequestGenesysCabmov).forEach(val => {
				let index = this.listTipocomp.map((el) => parseInt(el.tipocompcod)).indexOf(parseInt(val.tipocompcod))
				if (index > -1 && type == 'INT' && this.listTipocomp[index].view) {
					con++
					nrocomp = (nrocomp == 'S/N') ? this.listTipocomp[index].sintetico + val.nrocomp : nrocomp
				} else if (index > -1 && type == 'LEG' && !this.listTipocomp[index].view) {
					nrocomp = val.nrocomp
				}
			})
			if (type == 'INT' && nrocomp != 'S/N' && con > 1) {
				nrocomp = (con == 2) ? nrocomp + "+" : nrocomp + "+" + (con - 1)
			}
			return nrocomp
		},
		getCodbaretiGenesys(shippingRequestGenesysCabmov) {
			let codbareti = ''
			if (shippingRequestGenesysCabmov.length > 0)
				codbareti = shippingRequestGenesysCabmov[0].codbareti
			return codbareti

		},
		getRecipientData(shippingRequestRecipientData, type) {
			let data
			if (shippingRequestRecipientData.length == 1) {
				switch (type) {
					case 'ID': data = shippingRequestRecipientData[0].id; break;
					case 'SENDTO': data = shippingRequestRecipientData[0].sendto; break;
					case 'ADDRESS': data = shippingRequestRecipientData[0].address; break;
					case 'COMUNA': data = shippingRequestRecipientData[0].comuna; break;
					case 'PHONE': data = shippingRequestRecipientData[0].phone; break;
					case 'NUMBER_DOCUMENT': data = shippingRequestRecipientData[0].number_document; break;
					case 'EMAIL': data = shippingRequestRecipientData[0].email; break;
					case 'PAIDSHIPPING': data = (shippingRequestRecipientData[0].paid_shipping == 1); break;
					case 'TRANSPORTSID': data = shippingRequestRecipientData[0].transport_id; break;
					case 'TRANSPORTS': data = shippingRequestRecipientData[0].transport; break;
					default: data = 'NOT'; break;
				}
			}
			return data
		},
		initMixinShippingRequest() {
			this.setListeningShippingRequest()
			this.setListeningShippingRequestTrackingsShippingRequest()
		},
		resultAddShippingRequestTrackingsShippingRequest(response) {
			this.updateStatus(response.data.data)
			this.socketEmit(['NEW_SHIPPING_REQUEST_TRACKINGS_SHIPPING_REQUEST'], response.data.data)
		},
		resultAxiosLocalShippingRequest(responseLocal, response) {
			switch (responseLocal) {
				case 'getShippingRequestResult': this.getShippingRequestResult(response); break;
				case 'resultGetAllShippingsRequest': this.resultGetAllShippingsRequest(response); break;
				case 'resultDeleteShippingRequest': this.resultDeleteShippingRequest(response); break;
				case 'resultAddShippingRequestTrackingsShippingRequestPOST': this.resultAddShippingRequestTrackingsShippingRequest(response); break;
				case 'resultSaveShippingRequestPOST': this.resultSaveShippingRequestPOST(responseLocal, response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
			this.$emit('hideLockScreen')
		},
		resultGetAllShippingsRequest(response) {
			this.searchingShippingsRequest = false
			if (response.data.success == true) {
				this.listShippingsRequest = response.data.data
				this.paginationListShippingsRequest = response.data.paginate
			}
			this.getAllShippingsRequestResultLocal(response)
		},
		getAllShippingsRequestResultLocal(response) {
			console.log('getAllShippingsRequestResultLocal no desarrollado', response)
		},
		resultDeleteShippingRequest(response) {
			if (response.data.success) {
				this.deleteItemListShippingsRequest(response.data.data)
				this.socketEmit(['DELETE_SHIPPING_REQUEST'], response.data.data)
			}
			this.resultDeleteShippingRequestLocal(response)
		},
		resultDeleteShippingRequestLocal(response) {
			console.log('resultDeleteShippingRequest no desarrollado', response)
		},
		resultSaveShippingRequestPOST(responseLocal, response) {
			if (response.data.success) {
				if (responseLocal == 'resultSaveShippingRequestPOST') {
					this.addListShippingsRequest(response.data.data)
					this.socketEmit(['NEW_SHIPPING_REQUEST'], response.data.data)
				} else if (responseLocal == 'resultSaveShippingRequestPUT') {
					this.updateItemListShippingsRequest(response.data.data)
					this.socketEmit(['UPDATE_SHIPPING_REQUEST'], response.data.data)
				}
				this.clearObjectShippingRequest()
				console.log('Guardado con exito')
			} else {
				console.log(response)
				//this.setErrorSaveTicketLocal(response)
			}
			this.resultSaveShippingRequestPOSTLocal(responseLocal, response)
		},
		saveShippingRequest() {
			this.savingShippingsRequest = true
			let method = (this.objectShippingRequest.id == 0) ? 'POST' : 'PUT'
			this.$emit('showLockScreen', 'Guardando datos . . .')
			if (method == 'POST') {
				let url = this.getApiBackend + this.methods.shippingRequestCreate
				this.axiosActionIS(url, method, 'saveShippingRequestResult', this.objectShippingRequest)
			} else if (method == 'PUT') {
				let url = this.getApiBackend + this.methods.shippingRequestShow + this.objectShippingRequest.id + '/update'
				this.axiosActionIS(url, method, 'saveShippingRequestResult', this.objectShippingRequest)
			}
		},
		saveShippingRequestResult(response) {
			this.savingShippingsRequest = false
			if (response.data.success == true) {
				this.setObjectShippingRequest(response.data.data)
			} else {
				alert('hubo problema al generar la operación')
			}
			this.saveShippingRequestResultLocal(response)
		},
		saveShippingRequestResultLocal(response) {
			console.log('saveShippingRequestResult no desarrollado', response)
		},
		setCabmovs(tipocompcod, fecmov, succod, codbareti, nrocomp) {
			this.objectShippingRequest.shipping_request_genesys_cabmov.push({
				'tipocompcod': tipocompcod,
				'fecmov': fecmov,
				'succod': succod,
				'codbareti': codbareti,
				'nrocomp': nrocomp
			});
		},
		setRecipientData(sendto, number_document, email, address, comuna, phone, paid_shipping, transportId, transport) {
			if (this.objectShippingRequest.shipping_request_recipient_data.length == 1) {
				this.objectShippingRequest.shipping_request_recipient_data[0].sendto = sendto
				this.objectShippingRequest.shipping_request_recipient_data[0].number_document = number_document
				this.objectShippingRequest.shipping_request_recipient_data[0].email = email
				this.objectShippingRequest.shipping_request_recipient_data[0].address = address
				this.objectShippingRequest.shipping_request_recipient_data[0].comuna = comuna
				this.objectShippingRequest.shipping_request_recipient_data[0].phone = phone
				this.objectShippingRequest.shipping_request_recipient_data[0].paid_shipping = paid_shipping
				this.objectShippingRequest.shipping_request_recipient_data[0].transport_id = transportId
				this.objectShippingRequest.shipping_request_recipient_data[0].transport = transport
			}
		},
		setRecipientData_Old(sendto, number_document, email, address, comuna, phone, paid_shipping, transportId, transport) {
			this.objectShippingRequest.recipientData.sendto = sendto
			this.objectShippingRequest.recipientData.number_document = number_document
			this.objectShippingRequest.recipientData.email = email
			this.objectShippingRequest.recipientData.address = address
			this.objectShippingRequest.recipientData.comuna = comuna
			this.objectShippingRequest.recipientData.phone = phone
			this.objectShippingRequest.recipientData.paid_shipping = paid_shipping
			this.objectShippingRequest.recipientData.transportId = transportId
			this.objectShippingRequest.recipientData.transport = transport
			console.log(this.objectShippingRequest)
		},
		setRecipientDataTransport(item) {
			this.objectShippingRequest.recipientData.transport = item.name
		},
		setObjectShippingRequest(item) {
			for (const property in item) {
				this.objectShippingRequest[property] = item[property]
			}
		},
		setListeningShippingRequest() {
			this.sockets.subscribe('DELETE_SHIPPING_REQUEST', (data) => { this.deleteItemListShippingsRequest(data.body) })
			this.sockets.subscribe('NEW_SHIPPING_REQUEST', (data) => { this.addListShippingsRequest(data.body) })
			this.sockets.subscribe('UPDATE_SHIPPING_REQUEST', (data) => { this.updateItemListShippingsRequest(data.body) })
		},
		setListeningShippingRequestTrackingsShippingRequest() {
			this.sockets.subscribe('NEW_SHIPPING_REQUEST_TRACKINGS_SHIPPING_REQUEST', (data) => { this.updateStatus(data.body) })
		},
		updateItemListShippingsRequest(data) {
			let index = this.listShippingsRequest.map(e => parseInt(e.id)).indexOf(data.id)
			if (index > -1) {
				for (const property in data) {
					this.listShippingsRequest[index][property] = data[property]
				}
			}
		},
		updateStatus(shippingRequestTrackingsShippingRequest) {
			if (Object.entries(shippingRequestTrackingsShippingRequest.statu).length > 0) {
				let index = this.listShippingsRequest.map((el) => parseInt(el.id)).indexOf(parseInt(shippingRequestTrackingsShippingRequest.shipping_request_id))
				if (index > -1) {
					this.listShippingsRequest[index].status_id = shippingRequestTrackingsShippingRequest.statu.id
					this.listShippingsRequest[index].status = shippingRequestTrackingsShippingRequest.statu.name
					this.listShippingsRequest[index].color = shippingRequestTrackingsShippingRequest.statu.color
					this.listShippingsRequest[index].consider = (shippingRequestTrackingsShippingRequest.statu.id > 9) ? true : false
				}
			}
			let ind = this.trackingsShippingRequestOrder.map((el) => parseInt(el.trackings_shipping_request_id)).indexOf(parseInt(shippingRequestTrackingsShippingRequest.trackings_shipping_request_id))
			if (ind > -1) {
				let inde = this.listShippingsRequest.map((el) => parseInt(el.id)).indexOf(parseInt(shippingRequestTrackingsShippingRequest.shipping_request_id))
				if (inde > -1) {
					for (let i = 0; i < this.listShippingsRequest[inde].orders.length; i++) {
						this.addOrderTrackingsOrder(this.listShippingsRequest[inde].orders[i].id, this.trackingsShippingRequestOrder[ind].trackings_order_id, 'Pedido Atendido')
					}
				}
			}
		}
	},
};

export default shippingRequest;